import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { PlannedSegment } from '../work-item'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderDataActivationDirective,
  ElderTableComponent,
  ElderTranslatePipe,
  ElderPaneHeaderComponent,
  ElderPaneActionsComponent,
  ElderPaneContentComponent,
  ElderPaneTitleComponent,
} from '@elderbyte/ngx-starter'
import { MatSort } from '@angular/material/sort'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { BehaviorSubject } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { MatChipSet, MatChip } from '@angular/material/chips'
import { ItemPlannedSegmentEnrichmentsComponent } from '../item-planned-segment-enrichments/item-planned-segment-enrichments.component'
import { MatIcon } from '@angular/material/icon'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { MatIconButton } from '@angular/material/button'

@Component({
  selector: 'app-item-planned-segments',
  imports: [
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderDataActivationDirective,
    ElderTableComponent,
    ElderTranslatePipe,
    AsyncPipe,
    MatChipSet,
    MatChip,
    ItemPlannedSegmentEnrichmentsComponent,
    ElderPaneHeaderComponent,
    ElderPaneActionsComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
  ],
  templateUrl: './item-planned-segments.component.html',
  styleUrl: './item-planned-segments.component.scss',
})
export class ItemPlannedSegmentsComponent {
  public readonly plannedSegments = input.required<PlannedSegment[]>()
  public readonly requestEnrichment = output()
  protected readonly selected$ = new BehaviorSubject<PlannedSegment | null>(null)

  protected requestEnrichmentCmd(): void {
    this.requestEnrichment.emit()
  }
}
